<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <circle
    cx="12.0001"
    cy="12"
    r="9.5"
    fill="white"
    [style.stroke]="color"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M9.49813 7.6687H14.6413L17.0341 11.4367L10.459 11.8889L7.14317 11.1541L9.49813 7.6687Z"
    [style.fill]="fillColor"
  />
  <path
    d="M12.1914 17.1675L16.439 12.6423V11.7817L6.97207 11.6429L12.1914 17.1675Z"
    [style.fill]="fillColor"
  />
  <path
    d="M7.01865 11.6711H16.9829"
    [style.stroke]="color"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.12901 10.9969C6.91951 11.3687 6.96902 11.8325 7.25229 12.1516L11.2523 16.6588C11.4421 16.8727 11.7143 16.995 12.0002 16.995C12.2861 16.995 12.5584 16.8727 12.7481 16.6588L16.7481 12.1516C17.0314 11.8325 17.0809 11.3688 16.8714 10.997L15.185 8.00416C15.0078 7.68964 14.6748 7.49506 14.3138 7.49506H9.68661C9.3256 7.49506 8.99263 7.68964 8.81541 8.00415L7.12901 10.9969Z"
    [style.stroke]="color"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
